import * as React from "react";
import {useSelector} from "react-redux";
import {Link, NavLink} from "react-router-dom";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {BellIcon} from "@web2/ap-icons";
import {apAppLink} from "@web2/ap-routes";

import {IAPTheme} from "../app/ap_client";
import {IAPStore} from "../app/reducers/ap_reducer";
import {list_unstyled, mr_sm} from "../app/styles/helpers";
import {logoAp} from "../login/components/LoginForm";

export const Navigation = () => {
    const userEmail = useSelector((store: IAPStore) => store.account.userData?.email);

    return (
        <header css={headerHolder}>
            <Nav>
                <div css={logoHolder}>
                    <a href="/" />
                </div>

                <ul css={[navList]}>
                    <li css={navListItem}>
                        <NavLink to={"#"}>
                            <BellIcon size="1.5" fillColor="#fff" css={[mr_sm]} /> Zgłoszenia
                        </NavLink>
                    </li>
                </ul>

                <ul css={navUserList}>
                    <li css={navListItem}>
                        <Link to={apAppLink.logout()}>Wyloguj {userEmail && <strong>{userEmail}</strong>}</Link>
                    </li>
                </ul>
            </Nav>
        </header>
    );
};

const headerHolder = (theme: IAPTheme) => css`
    height: 5.1rem;
    border-bottom: 1px solid ${theme.colors.brand_primary};
`;

const Nav = styled.nav`
    display: flex;
    flex-direction: row;
`;

const logoHolder = css`
    padding: 0.6rem 0;
    height: 5rem;

    > a {
        width: 27rem;
        height: 100%;
        display: block;
        background-image: url(${logoAp});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
    }
`;

const navList = css`
    ${list_unstyled};
    flex-grow: 1;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const navListItem = (theme: IAPTheme) => css`
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    > a {
        padding: 1.5rem 3rem;
        display: block;
        color: ${theme.colors.text_color};

        &:hover,
        &:focus,
        &.active,
        &:active {
            background-color: ${theme.colors.brand_primary};
            color: #fff;
            text-decoration: none;
        }
    }
`;

const navUserList = css`
    ${list_unstyled};
    margin: 0;
`;
